import type { paths, CreateGameLineupsDto } from '@orlikfy/api-interfaces';

export type { GameLineupsDto, GameLineupsDtoLineup, LineupPlayer } from '@orlikfy/api-interfaces';

// GET /game-lineups/{gameId}
export const GET_GAME_LINEUPS_PATH = '/game-lineups/{gameId}' as const satisfies keyof paths;
type GetGameLineupsOperation = paths[typeof GET_GAME_LINEUPS_PATH]['get'];
export type GetGameLineupsPathParams = GetGameLineupsOperation['parameters']['path'];
export type GetGameLineupsResponse = GetGameLineupsOperation['responses'][200]['content']['application/json'];

// PUT /game-lineups/{gameId}
export const UPDATE_GAME_LINEUPS_PATH = '/game-lineups/{gameId}' as const satisfies keyof paths;
type UpdateGameLineupsOperation = paths[typeof UPDATE_GAME_LINEUPS_PATH]['put'];
export type UpdateGameLineupsPathParams = UpdateGameLineupsOperation['parameters']['path'];
export type UpdateGameLineupsBody = CreateGameLineupsDto;
export type UpdateGameLineupsResponse = UpdateGameLineupsOperation['responses'][200]['content']['application/json'];
